const TASK_LABELS: Record<string, string> = {
  verify_setup: 'setup confirmed — verifying next run',
  process_document: 'uploaded — processing next run',
  process_email: 'email queued for next run',
  find_order_doc: 're-hunt queued for next run',
  confirm_balanced: 'edits applied — confirming next run',
};

export function taskLabel(kind: string): string {
  return TASK_LABELS[kind] || `queued: ${kind.replace(/_/g, ' ')}`;
}


export function todayDateString(): string {
  return new Date().toISOString().slice(0, 10);
}
